import './style.scss'
import './v4/scripts.js'

import { Media } from '../../../js/utils/const'
import { saleEndDate } from '../../../js/components/SaleEndDate/SaleEndDate'
import { Timer } from '../../../js/components/Timer/Timer'
import {pushDSPCounter} from '../../../js/libs/pixel'
import { showOrderModal } from '../../popups/v1/OrderModal/scripts'

export default !function () {
  const block = document.querySelector('.start-screen-v3')

  if (!block) {
    return
  }

  const blockName = block.closest('[data-block-name]')?.dataset.blockName || 'Блок без названия'
  const button = block.querySelector('.start-screen-v3__button')

  if (button) {
    const siteArea = button.dataset.pixel
    const blocksWithFooter = document.querySelectorAll('.footer')
    const blocksWithButton = [...document.querySelectorAll('.block:not(.start-screen-v3)')]
      .filter(block => block.querySelector('.ui-button'))
    const blocks = [...blocksWithButton, ...blocksWithFooter]
    const bar = document.querySelector('.start-screen-v3__bar')

    button.addEventListener('click', (evt) => {
      evt.preventDefault()

      const buttonType = button.dataset.actionButton || (button.dataset.redirectLink && 'redirect')

      if (buttonType) {
        window.$analytics?.push('all-block-consult-button-click', {
          blockName,
          buttonType,
          buttonText: button.textContent
        })
      }

      if (button.dataset.actionButton === 'order-modal') {
        const blockName = button.closest('[data-block-name]')?.dataset.blockName ?? 'Блок без названия'
        showOrderModal({ blockName })
      }

      siteArea && pushDSPCounter(siteArea)
    })

    let visibleCount = 1
    const media = window.matchMedia(`(max-width: ${Media.LG_MAX}px)`);

    const changeVisibleButton = (entries) => {
      entries.forEach(entry => {
        entry.isIntersecting ? ++visibleCount : --visibleCount
        visibleCount = visibleCount > 0 ? visibleCount : 0

        visibleCount
          ? bar.classList.add('start-screen-v3__bar--hidden')
          : bar.classList.remove('start-screen-v3__bar--hidden')
      })
    }

    const observer = new IntersectionObserver(changeVisibleButton)

    const mediaChangeHandler = () => {
      media.matches
        ? blocks.forEach(block => observer.observe(block))
        : observer.disconnect()
    }

    mediaChangeHandler()
    media.addEventListener('change', mediaChangeHandler)
  }

  // init timer
  const timers = block.querySelectorAll('[data-type=timer]')

  timers.forEach((timerWrapper) => {
    saleEndDate
      .addObserver(time => new Timer({ time, timerWrapper }))
  });
}()
